<!--
 * @Description: 
 * @Date: 2021-07-19 16:35:52
-->
<template>
  <div class="box">
    <el-form label-width="120px" :model="formParams" ref="form">
      <el-form-item
        :label="item.label"
        v-for="item in form"
        :key="item.key"
        :prop="item.key"
        :rules="item.rules || []"
      >
        <template v-if="item.slot === 'dicSelect'">
          <dic-select
            @dic-select-obj="
              val => {
                formParams[item.key] = val.enterpriseId;
              }
            "
            :fuzzyDef="() => {}"
            :prop="{
              label: 'enterpriseName',
              code: 'enterpriseId'
            }"
            :ajaxQueryObj="{}"
            ajaxQuery="enterpriseName"
            :placeholder="item.placeholder"
            class="data-item"
          ></dic-select>
        </template>
        <template v-if="item.slot === 'input'">
          <el-input
            disabled
            :placeholder="item.placeholder"
            v-model="formParams[item.key]"
            class="data-item"
          />
        </template>
        <template v-if="item.slot === 'date'">
          <el-date-picker
            :placeholder="item.placeholder"
            :value-format="item.valueFormat"
            v-model="formParams[item.key]"
            class="data-item"
            :type="item.type || 'month'"
          ></el-date-picker>
        </template>
        <template v-if="item.slot === 'custom'">
          <component
            :is="item.component"
            :value="formParams[item.key]"
            v-bind="item.attrs"
            v-on="item.listener"
          ></component>
        </template>
      </el-form-item>
    </el-form>
    <div style="text-align: center;padding-bottom:15px;">
      <el-button type="primary" @click="$xrkDialog.remove()">关闭</el-button>
    </div>
  </div>
</template>

<script>
import { taxPayment } from '@/api/ajax';
import dicSelect from '@/components/Common/dicSelect.vue';
import OpenNewWin from '@/tools/openNewWin';
export default {
  name: 'add-dutypaid-proof',
  components: { dicSelect },
  props: { id: [Number, String] },
  data() {
    return {
      formParams: {}
    };
  },
  computed: {
    form() {
      return [
        {
          label: '客户企业',
          slot: 'input',
          key: 'inEnterpriseName'
        },
        {
          label: '纳税人识别号',
          slot: 'input',
          key: 'enterpriseIdentifierNo'
        },
        {
          label: '所得月份',
          slot: 'input',
          key: 'proofMonth'
        },
        {
          label: '完税人数',
          slot: 'input',
          key: 'peopleCount'
        },
        {
          label: '税款所属期起',
          slot: 'input',
          key: 'startDt'
        },
        {
          label: '税款所属期止',
          slot: 'input',
          key: 'endDt'
        },
        {
          label: '完税证明附件',
          slot: 'custom',
          key: 'taxPaymentAnnexList',
          component: {
            props: { value: Array },
            render() {
              const { value = [] } = this;
              return (
                <div>
                  {value.map(item => {
                    return (
                      <el-button
                        type="text"
                        onClick={() => {
                          const newWin = new OpenNewWin();
                          newWin.createWin();
                          newWin.setUrl(item.attachmentUrl);
                        }}
                      >
                        {item.attachementName}
                      </el-button>
                    );
                  })}
                </div>
              );
            }
          }
        }
      ];
    }
  },
  async created() {
    const {
      data: { data }
    } = await taxPayment.detail({ id: this.id });
    const { proofType, csoEnterpriseName, supplierEnterpriseName } = data;
    this.formParams = {
      ...data,
      ['enterpriseName']:
        ['', supplierEnterpriseName, csoEnterpriseName][proofType] || '-'
    };
  }
};
</script>
<style lang="scss" scoped>
.box {
  .el-form {
    display: flex;
    flex-wrap: wrap;
    &-item {
      width: 50%;
      margin-bottom: 45px;
    }
  }
  .data-item {
    width: 340px;
  }
}
</style>
